export const zeroLeft = (n: number) => Math.floor(n).toString().padStart(2, '0');